import React, { useEffect, useState } from "react";
import apiClient from "../../../utils/apiClient";
import OptimusToggleTable from "./OptimusToggleTable";
import server from "../../../utils/serverConfig";

export default function OptimusToggleData() {
  const [toggleData, setToggleData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchOptimusToggleData = () => {
    let config = {
      method: "get",
      url: `${server.godseye.baseUrl}get-optimus-toggles`,
    };

    apiClient
      .request(config)
      .then((response) => {
        console.log("optimus toggle data", response.data);
        setToggleData(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => { 
    fetchOptimusToggleData();
  }, []);

  // Handle switch toggle update with optimistic UI update
  const handleToggleUpdate = async (toggleName, currentValue) => {
    const newValue = !currentValue;
    
    console.log("Toggle Name:", toggleName);
    console.log("Current Value:", currentValue);  
    console.log("Updated Value:", newValue);

    // Optimistically update the UI immediately
    setToggleData(prevData => 
      prevData.map(item => 
        item.toggle_name === toggleName 
          ? { ...item, enabled: newValue, updated_at: new Date().toISOString() }
          : item
      )
    );

    setLoading(true);

    let config = {
      method: "post",
      url: `${server.godseye.baseUrl}update-optimus-toggles`,
      data: {
        toggle_name: toggleName,
        enabled: newValue,
      },
    };

    try {
      const response = await apiClient.request(config);
      console.log("Toggle update successful:", response.data);
      
      // Optionally refresh data from server to ensure sync
      // fetchOptimusToggleData();
      
    } catch (error) {
      console.error("Toggle update failed:", error);
      
      // Revert the optimistic update on error
      setToggleData(prevData => 
        prevData.map(item => 
          item.toggle_name === toggleName 
            ? { ...item, enabled: currentValue } // Revert to original value
            : item
        )
      );
      
      // You might want to show an error message to the user here
      alert("Failed to update toggle. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  console.log("toggle Data", toggleData);

  return (
    <div className="flex flex-col relative w-full max-h-screen">
      <div className="flex items-center justify-between space-x-4 ">
        <div className="flex justify-between items-center h-[40px] px-6 w-full">
          <p className="flex items-center text-lg font-semibold text-white">
            Optimus Data Toggles {loading && <span className="ml-2 text-sm text-gray-400">(Updating...)</span>}
          </p>
        </div>
      </div>

      <div className="flex h-full flex-col relative w-full">
        <div className="flex min-w-full pt-2">
          <OptimusToggleTable 
            toggleData={toggleData} 
            handleToggleUpdate={handleToggleUpdate} 
          />
        </div>
      </div>
    </div>
  );
}